var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTableCellFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.69208C16 7.44727 15.9027 7.21248 15.7296 7.03937C15.5565 6.86626 15.3217 6.76901 15.0769 6.76901H9.07692L7.96923 5.29208C7.88325 5.17744 7.77176 5.08439 7.64358 5.0203C7.51541 4.95622 7.37407 4.92285 7.23077 4.92285H4.92308C4.67826 4.92285 4.44347 5.0201 4.27036 5.19321C4.09725 5.36632 4 5.60111 4 5.84593V14.1536C4 14.3984 4.09725 14.6332 4.27036 14.8063C4.44347 14.9794 4.67826 15.0767 4.92308 15.0767H15.0769C15.3217 15.0767 15.5565 14.9794 15.7296 14.8063C15.9027 14.6332 16 14.3984 16 14.1536V7.69208Z",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTableCellFolder);
export default __webpack_public_path__ + "static/media/icn_table_cell_Folder.47d7f455c3508c865cab78611344aba9.svg";
export { ForwardRef as ReactComponent };